import Modal from "../../../global/Modal";
import DeleteModal from "../../Common/Modals/components/DeleteModal";

export default function ContractsDeleteModal({
  openModal,
  handleCloseModal,
  handleDelete,
  isDeleting,
}) {
  return (
    <Modal open={openModal} onClose={handleCloseModal} maxWidth="xs">
      <div className="flex flex-row items-center justify-center p-2">
        <DeleteModal
          additionalDetails={{
            deleteLabel: "Delete Contract",
            handleCancel: handleCloseModal,
            handleDelete,
            isDeleting,
          }}
        />
      </div>
    </Modal>
  );
}
